import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { HeartPulse, CalendarClock, AlertTriangle } from "lucide-react";
import api, { fmtDate } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const ParametriDaMisurareBox = ({ className = "" }) => {
  const { selectedStructure, structures = [] } = useAuth();
  const nav = useNavigate();
  const allStruct = selectedStructure === "all";
  const structOf = (id) => structures.find((s) => s.id === id) || {};
  const { data: due = [] } = useQuery({
    queryKey: ["parametri-da-misurare", selectedStructure],
    queryFn: async () => { try { return (await api.get("/dashboard/parametri-da-misurare", { params: { structure_id: selectedStructure } })).data; } catch { return []; } },
    refetchInterval: 30000,
  });
  const nAllerta = due.filter((d) => d.allerta).length;
  return (
    <div className={`gr-card p-5 ${className}`} data-testid="parametri-da-misurare-card">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-head font-bold flex items-center gap-2"><HeartPulse size={18} className="text-indigo-600" /> Parametri da misurare oggi</h2>
        <div className="flex items-center gap-2 shrink-0">
          {nAllerta > 0 && <span className="text-[11px] font-bold rounded-full px-2 py-0.5 bg-red-100 text-red-700 inline-flex items-center gap-1" data-testid="parametri-da-misurare-allerta"><AlertTriangle size={12} /> {nAllerta} in ritardo</span>}
          <button onClick={() => nav("/parametri")} className="text-xs font-semibold text-primary" data-testid="parametri-da-misurare-link">Apri →</button>
          <span className={`text-xs font-bold rounded-full px-2 py-0.5 tabnum ${nAllerta > 0 ? "bg-red-600 text-white" : due.length ? "bg-indigo-100 text-indigo-700" : "bg-secondary text-muted-foreground"}`} data-testid="parametri-da-misurare-count">{due.length}</span>
        </div>
      </div>
      {due.length === 0 ? (
        <div className="text-sm text-muted-foreground">Nessun parametro da misurare oggi</div>
      ) : (
        <div className="grid grid-cols-1 gap-2 max-h-[304px] overflow-y-auto pr-1" data-testid="parametri-da-misurare-list">
          {due.map((d) => (
            <button key={d.ospite_id} onClick={() => nav("/parametri")} data-testid={`parametri-da-misurare-${d.ospite_id}`}
              className={`w-full flex flex-col items-start gap-0.5 text-sm rounded-lg border px-3 py-2 text-left transition-colors ${d.allerta ? "bg-red-50 border-red-300 hover:bg-red-100" : "bg-indigo-50 border-indigo-200 hover:bg-indigo-100"}`}>
              <span className="w-full flex items-center justify-between gap-2">
                <span className="font-semibold truncate flex items-center gap-1.5">{d.allerta && <AlertTriangle size={13} className="text-red-600 shrink-0" />}{d.cognome} {d.nome}{allStruct ? <span className="text-xs text-muted-foreground font-normal"> · {structOf(d.structure_id).nome || ""}</span> : ""}</span>
                <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full text-white shrink-0 ${d.allerta ? "bg-red-600" : "bg-indigo-600"}`} data-testid={`parametri-da-misurare-freq-${d.ospite_id}`}>ogni {d.freq}g</span>
              </span>
              <span className={`text-[11px] flex items-center gap-1 ${d.allerta ? "text-red-700" : "text-muted-foreground"}`}>
                <CalendarClock size={11} />
                {d.giorni == null ? "mai misurato" : `ultima ${fmtDate(d.ultima)} · ${d.giorni}g fa`}
                {d.ritardo != null && d.ritardo > 0 ? <span className="font-bold"> · +{d.ritardo}g di ritardo</span> : null}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
